import * as React from 'react';
import styled from 'styled-components';
import { UserToken } from '../../../amorg-common';
import { tablet } from '../../../designSystem/BreakPoints';
import { PageGuideDefinition } from '../../../designSystem/PageGuide';
import { MainNavigation } from './elements/mainNavigation/MainNavigation';
import { PageTopBarBreadcrumb, TopBar } from './elements/topBar/TopBar';
import { Footer } from './elements/Footer';

export type MemberLayoutProps = React.PropsWithChildren<{
    activeUser: UserToken,
    selectedMenuItemKey?:string,
    guide?:PageGuideDefinition,
    breadCrumbs?:PageTopBarBreadcrumb[]
}>

export const MemberLayout = ({ activeUser, selectedMenuItemKey, guide, breadCrumbs, children }: MemberLayoutProps) => {

    return (
        <Main>
            <TopBar activeUser={activeUser} guide={guide} breadCrumbs={breadCrumbs} />

            <MainNavigation activeUser={activeUser} selectedMenuItemKey={selectedMenuItemKey} />

            <CoreContent className="mainContent">
                {children}
            </CoreContent>

            <Footer siteId={activeUser.siteId} />
        </Main>
    )
};

const Main = styled.div`
    background: #f6f6f6;
    display:grid;
    min-height: 100%;
    grid-template-columns: 320px minmax(0, 1fr);
    grid-template-rows: min-content auto min-content;
    grid-template-areas:
        "navigation topbar"
        "navigation content"
        "navigation footer";

    @media (max-width: ${tablet}px) {
        grid-template-columns: auto;
        grid-template-rows: 56px auto auto;
        grid-template-areas:
        "topbar"
        "content"
        "footer";
    }
`;

const CoreContent = styled.div`
    
    position: relative;
    z-index: 10;
    grid-area: content;

    width:100%;

    display: flex;
    flex-direction: column;
    gap: 16px;
`;
